<template>
  <div class="view-file" v-if="seen" @click="close_box" @contextmenu="notallowed">
    <div class="header">
      <div class="left">
        <span @click="close_box">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24" @click="close_box" class="close">
            <path fill="#fff" d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
          </svg>
        </span>
        <span>
          {{ name }}
        </span>
      </div>
      <div class="right">
        <span @click="print">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#fff"
              d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z" />
          </svg>
        </span>
        <span @click="download">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#fff" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
          </svg>
        </span>
        <!--<span>
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                        <path fill="#fff" d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                    </svg>
                </span>-->
      </div>
    </div>
    <div class="img">
      <img ref="img" :src="path" />
    </div>
    <div class="footer">
      <div class="floor">
        <span @click="zoomin">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#fff" d="M19,13H5V11H19V13Z" />
          </svg>
        </span>
        <span @click="reset">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#fff"
              d="M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5A6.5,6.5 0 0,0 9.5,3A6.5,6.5 0 0,0 3,9.5A6.5,6.5 0 0,0 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z" />
          </svg>
        </span>
        <span @click="zoomout">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#fff" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      name: '',
      seen: false,
      index: '',
      id: '',
      path: '',
      download_url: process.env.VUE_APP_URL
    }
  },
  methods: {
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      return str.length > 38 ? str.substr(0, 38) + '...' : str
    },
    print() {

    },
    download() {
      let id = this.id
      let token = cookies.getCookie('token')

      let a = document.createElement('a')
      a.setAttribute('download', true)
      a.setAttribute('href', this.download_url + "/download?id=" + id + "&token=" + token)
      a.hidden = true
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    zoomin() {

    },
    reset() {

    },
    zoomout() {
      this.$refs.img.height = (this.$refs.img.height / this.$refs.img.width) * this.$refs.img.height
      this.$refs.img.width = (this.$refs.img.height / this.$refs.img.width) * this.$refs.img.width
    },
    load(index, id) {
      this.index = index
      this.id = id
      this.seen = true
      this.name = this.str_text(this.$store.getters.DIRECTORY_CHILDREN[index].dir) + this.$store.getters.DIRECTORY_CHILDREN[index].extname

      let that = this

      let data = {
        token: cookies.getCookie('token'),
        id: id,
        db: this.$store.getters.DIRECTORY_CHILDREN[index].db
      }

      this.$socket.emit('loadimage', data, function (data) {
        if (data.data === true) {
          that.path = data.img
        }

        if (data.data === false) {
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    notallowed(e) {
      e.preventDefault();
    },
    close_box(evt) {
      if (evt.target.className === 'view-file' || evt.target.className.baseVal === 'close') {
        this.seen = false
        return
      }
    }
  }
}
</script>